import { useTranslation } from "react-i18next";
import { Badge, DefaultMantineColor, Flex, Text, Tooltip } from "@mantine/core";
import { CellContext } from "@tanstack/react-table";
import { CampaignApplicationResolutionStatus, CampaignApplicationState } from "src/graphql/generated/graphql";
import { CampaignApplicationRestApi } from "src/types";


export interface CellRoleProps extends CellContext<CampaignApplicationRestApi, unknown> { }
export const CellRole = ({ row }: CellRoleProps) => {
    const { t } = useTranslation(["common"]);

    let color: DefaultMantineColor;
    let text: string = t("campaignapplication_role_none");
    let badgeText: string;

    switch (row?.original?.state) {
        case CampaignApplicationState.Pending:
            switch (row?.original?.pendingResolution?.status) {
                case CampaignApplicationResolutionStatus.Selected:
                    color = "green";
                    text = t("campaignapplication_role_selected");
                    badgeText = t("campaignapplication_role_pending");
                    break;
                case CampaignApplicationResolutionStatus.Alternate:
                    color = "yellow";
                    text = t("campaignapplication_role_alternate");
                    badgeText = t("campaignapplication_role_pending");
                    break;
                case CampaignApplicationResolutionStatus.Rejected:
                    if (row?.original?.isUnselected) {
                        color = "red";
                        text = t("campaignapplication_role_unselected");
                        badgeText = t("campaignapplication_role_pending");
                        break;
                    }

                    color = "red";
                    text = t("campaignapplication_role_rejected");
                    badgeText = t("campaignapplication_role_pending");
                    break;
                default:
                    text = "INVALID";
                    break;
            }
            break;
        case CampaignApplicationState.Resolved:
            switch (row?.original?.latestResolution?.status) {
                case CampaignApplicationResolutionStatus.Selected:
                    color = "green";
                    text = t("campaignapplication_role_selected");
                    break;
                case CampaignApplicationResolutionStatus.Alternate:
                    color = "yellow";
                    text = t("campaignapplication_role_alternate");
                    break;
                case CampaignApplicationResolutionStatus.Rejected:
                    if (row?.original?.isUnselected) {
                        color = "red";
                        text = t("campaignapplication_role_unselected");
                        break;
                    }

                    color = "red";
                    text = t("campaignapplication_role_rejected");
                    break;
                default:
                    text = "INVALID";
                    break;
            }
    }

    const textNode = (
        <Text color={color}>
            {text}
        </Text>
    );

    return (
        <Flex display="inline-flex" align="center">
            {/* {row?.original?.isUnselected ? (
                <Tooltip label={t("campaignapplication_isunselected")}>
                    <Indicator color="red" position="middle-start" offset={-10} inline>
                        {textNode}
                    </Indicator>
                </Tooltip>
            ) : textNode} */}
            {textNode}
            {badgeText && (
                <Tooltip label={t("campaignapplication_role_pending_description")} withArrow>
                    <Badge
                        size="xs"
                        variant="dot"
                        color="grape"
                        mb="xs"
                        ml="4px"
                    >
                        {badgeText}
                    </Badge>
                </Tooltip>
            )}
        </Flex>
    );
};
